export default __webpack_public_path__ + "static/media/IACE.2570ae85.jpg";